import { Fragment, useEffect } from "react";

import { IconButton } from "../../controls";
import { Box } from "../../layout";
import Overlay from "../Overlay";
import MobileBottomSheetContent, {
  Props as ContentProps
} from "./components/MobileBottomSheetContent/MobileBottomSheetContent";

type Props = ContentProps & {
  children: React.ReactNode;
  onCloseClick?: () => void;
  scrollableBackground?: boolean;
};

export default function MobileBottomSheet({
  onCloseClick,
  children,
  scrollableBackground = false,
  ...contentProps
}: Props) {
  useEffect(() => {
    if (!scrollableBackground && document.body && document.body.style) {
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = "auto";
      };
    }
    return;
  }, [scrollableBackground]);

  return (
    <Fragment>
      <Overlay onCloseClick={onCloseClick} position="absolute" />

      <MobileBottomSheetContent {...contentProps}>
        {onCloseClick && (
          <Box position="absolute" top="0" right="0">
            <IconButton
              iconName="cross"
              accessibilityLabel="Close modal"
              onClick={onCloseClick}
              size="medium"
              tone="neutral"
              blend
            />
          </Box>
        )}
        {children}
      </MobileBottomSheetContent>
    </Fragment>
  );
}
